<template>
  <v-card>
    <v-container fluid>
      <v-row class="my-3 mx-2">
        <v-col>
          <v-row>
            <v-col cols="12" sm="11">
              <v-row align="center">
                <app-flag :from="rulesItem.from"></app-flag>
                <h2 class="text-h5" style="color: #ca0538">
                  {{ $t("searchRules.general_informations") }} :
                </h2>
              </v-row>
              <v-row class="pl-4 pt-2">
                <v-col>
                  <v-row>
                    <v-col class="px-0">
                      <h4 class="text-subtitle-1 font-weight-bold">
                        {{ $t("searchRules.official_name") }} :
                      </h4>
                      <p class="text-body-2">
                        {{ rulesItem.official_name }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <v-row align="baseline">
                        <h4 class="text-subtitle-1 font-weight-bold">
                          {{ $t("searchRules.nature") }} :
                        </h4>
                        <p class="text-body-2 mb-0 ml-2">
                          {{ rulesItem.nature }}
                        </p>
                      </v-row>
                      <v-row align="baseline">
                        <h4 class="text-subtitle-1 font-weight-bold">
                          {{ $t("searchRules.type") }} :
                        </h4>
                        <p class="text-body-2 mb-0 ml-2">
                          {{ rulesItem.type }}
                        </p>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="mt-4">
                      <v-row align="baseline">
                        <h4 class="text-subtitle-1 font-weight-bold">
                          {{ $t("searchRules.effective_date") }} :
                        </h4>
                        <p class="text-body-2 mb-0 ml-2">
                          {{ dateStr(rulesItem.date_start) }}
                        </p>
                      </v-row>
                      <v-row align="baseline">
                        <h4 class="text-subtitle-1 font-weight-bold">
                          {{ $t("searchRules.application_integration_date") }} :
                        </h4>
                        <p class="text-body-2 mb-0 ml-2">
                          {{ dateStr(rulesItem.date_tool) }}
                        </p>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-0">
                      <h4 class="text-subtitle-1 font-weight-bold">
                        {{ $t("searchRules.summary") }} :
                      </h4>
                      <p class="text-body-2">
                        {{ rulesItem.summary }}
                      </p>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col class="px-0">
                      <h4 class="text-subtitle-1 font-weight-bold">
                        {{ $t("searchRules.text_link") }} :
                      </h4>
                      <a
                        :href="rulesItem.source"
                        target="_blank"
                        class="text-decoration-none"
                      >
                        {{ $t("searchRules.clic_here") }}
                      </a>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" sm="1" align="end">
              <v-row justify="end">
                <v-btn
                  class="mb-3"
                  x-large
                  color="primary"
                  icon
                  @click="toggle_fav"
                >
                  <v-icon x-large v-if="love"> mdi-heart </v-icon>
                  <v-icon x-large v-else> mdi-heart-outline </v-icon>
                </v-btn>
              </v-row>
              <v-row justify="end" v-if="rulesItem.pdf">
                <v-btn
                  class="mb-3"
                  x-large
                  color="primary"
                  icon
                  @click="downloadPDF()"
                >
                  <v-icon x-large> mdi-download-box-outline </v-icon>
                </v-btn>
              </v-row>
              <v-row justify="end" v-if="rulesItem.video">
                <v-dialog v-model="dialog" width="1000px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      class="mb-3"
                      x-large
                      color="primary"
                      icon
                      @click="readVideo()"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-large> mdi-play-box-outline </v-icon>
                    </v-btn>
                  </template>
                  <!-- pop up -->
                  <div>
                    <video-player :url="url"></video-player>
                  </div>
                </v-dialog>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import AppFlag from "./AppFlag.vue";
import VideoPlayer from "./AppVideoPlayer.vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { monitore } from "./helpers/helpers";
export default {
  data() {
    return {
      dialog: false,
      url: "",
    };
  },
  props: {
    rulesItem: Object,
  },
  computed: {
    ...mapGetters(["rules_fav", "identity", "user"]), //array of id
    love() {
      let a = false;
      if (this.rules_fav.indexOf(this.rulesItem._id) < 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  beforeMount() {
    if (this.rulesItem.video) {
      this.url = `${process.env.VUE_APP_BASE_ROOT}/video/${this.rulesItem.video}?token=${this.user.id_token}`;
    } else {
      this.url = "";
    }
  },
  components: {
    AppFlag,
    VideoPlayer,
  },
  methods: {
    ...mapMutations(["addRuleFav", "deleteRuleFav"]),
    ...mapActions(["updateProfile"]),
    async toggle_fav() {
      if (this.love) {
        let index = this.rules_fav.indexOf(this.rulesItem._id);
        this.deleteRuleFav({ id: this.rulesItem._id, index: index });
        await this.updateProfile();
      } else {
        // is not fav -> add
        this.addRuleFav(this.rulesItem._id);
        monitore("Add rule fav", this.rulesItem._id);
        await this.updateProfile();
      }
    },
    readVideo() {
      monitore("Read rule video", this.rulesItem._id);
    },
    async downloadPDF() {
      let url = "/pdf/" + this.rulesItem.pdf;
      var request = { method: "GET", url: url, responseType: "blob" };
      try {
        var response = await this.axios(request);
        const blob = new Blob([response.data], { type: "application/pdf" });
        var data = URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.style = "display: none";
        a.href = data;
        a.download = this.rulesItem.usual_name;
        document.body.appendChild(a);
        a.click();
        monitore("Download rule pdf", this.rulesItem._id);
      } catch (err) {
        this.pdf = "";
        console.log(err);
      }
    },
    dateStr(date) {
      if (date) {
        const newdate = new Date(date);
        return newdate.toLocaleDateString("fr-FR");
      } else {
        return "";
      }
    },
  },
  watch: {
    dialog(val) {
      let player = document.querySelector("#video-player");
      if (!val) {
        player.pause();
      }
    },
  },
};
</script>